import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import './page-layout.css';
import './NotFoundPage.css';
import { useTranslation } from '../i18n/I18nContext';

/**
 * 404 — «всё остальное» в таблице роутов.
 *
 * До #1323 catch-all роута не было вовсе: незнакомый hash-путь не совпадал
 * ни с одним `<Route>`, и React Router не рендерил НИЧЕГО — пользователь
 * получал пустую полосу между шапкой и подвалом и не понимал, сломался сайт
 * или он ошибся адресом. Замер тогда: `/#/cars` — 1372 символа контента,
 * `/#/carz` — 574, то есть ровно шапка и подвал.
 *
 * Молчаливый редирект на главную рассматривали и отвергли: он прячет битые
 * ссылки вместо того, чтобы их показывать, — и от пользователя, и от нас.
 */
const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
  <div className="page not-found">
    <div className="page__container page__container--narrow not-found__inner">
      <p className="not-found__code" aria-hidden="true">404</p>
      <h1 className="not-found__title">{t('showcase.notFound.title', 'Page not found')}</h1>
      <p className="page__lead not-found__lead">
        {t('showcase.notFound.lead', 'The address may be mistyped, or the page has moved.')}
      </p>
      <div className="not-found__actions">
        <Link to="/cars">
          <Button size="lg">{t('showcase.notFound.cta', 'Browse cars')}</Button>
        </Link>
        <Link to="/" className="not-found__home">
          {t('showcase.notFound.home', 'Go to home page')}
        </Link>
      </div>
    </div>
    </div>
  );
};

export default NotFoundPage;
